import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export const useReorderDonationSurveyFieldsMutation = ({
	impersonationContext,
	onError,
	onSuccess,
}: {
	impersonationContext?: Api.IImpersonationContext;
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (data?: Api.CustomForm) => void;
}) => {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({ surveyId, fieldIds }: { surveyId: string; fieldIds: string[] }) => {
			return userSession.webServiceHelper.callAsync<Api.CustomForm>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `survey/donation/${surveyId}/customForm/fields/reorder`,
				}),
				'PUT',
				{ fieldIds }
			);
		},
		onError,
		onSuccess,
	});
};
